import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import classNames from 'classnames';
import { OutbreakShareURL } from '@mdc/constants';
import './DetectionReport.scss';
import { useTranslation } from 'react-i18next';

const DetectionReport = (props) => {
    const { data, tableLegend, currentReportDate, latestDate } = props;
    const [t, ready] = useTranslation();
    const noPaddingClass = classNames({}, 'pr-0', 'pl-0');

    const socialMediaDom = <Col sm={12} md={6} lg={6} className="align-self-center text-right socialMediaWrapper">
        <ul className="socialMedia">
            <li>
                <LinkedinShareButton
                    url={OutbreakShareURL}
                >
                    <i className="icon-linkedin-squared"></i>
                </LinkedinShareButton>
            </li>
            <li>
                <TwitterShareButton
                    url={OutbreakShareURL}
                >
                    <i className="icon-twitter"></i>
                </TwitterShareButton>
            </li>
            <li>
                <FacebookShareButton
                    url={OutbreakShareURL}
                >
                    <i className="icon-facebook-official"></i>
                </FacebookShareButton>
            </li>
            <p className="text-center">{t('Share this Report')}</p>
        </ul>
    </Col>;

    const belowOutbreakReportDom = <Row>
        <Col sm={12} md={6} lg={6}>
            {tableLegend}
        </Col>
        { socialMediaDom }
    </Row>;

    const trimString = (date) => {
        if (date && date.includes('outbreak-report/')) {
            return date.replace(/outbreak-report\//, '');
        }

        return date;
    };

    const totalDetectionTimeDom = data.map((item, index) => {
        return (
            <li key={index}>{item[1].total_detection_time.toFixed(2)}</li>
        );
    });

    const totalDetectionCountDom = data.map((item, index) => {
        return (
            <li key={index}>{item[1].total_detection_count}</li>
        );
    });

    if (!ready) {
        return;
    }

    return (
        <section className="outbreakReport">
            <div className="outbreakReportWrapper">
                <Row>
                    <Col xs={1} sm={1} md={1} lg={1}>
                        <div className="semiCircle"></div>
                    </Col>
                    <Col xs={10} sm={11} md={3} lg={3}>
                        <div className="outbreakLogo"></div>
                        <div className="content">
                            <h5>
                                {t('Executable Outbreak Report')}
                                <span className="date">
                                    {currentReportDate?.toLowerCase() === 'latest' ? trimString(latestDate) : trimString(currentReportDate)}
                                </span>
                            </h5>
                        </div>
                    </Col>

                    <Col className="outbreakReports">
                        <Row className="outebreakReportsItems pr-4">
                            <Col xs={6} md={5} lg={5} className={noPaddingClass}>
                                <h5>{t('MetaDefender Core')}</h5>
                                <ul className="fadedItems">
                                    <li>{t('8 Engines')}</li>
                                    <li>{t('12 Engines')}</li>
                                    <li>{t('16 Engines')}</li>
                                    <li>{t('20 Engines')}</li>
                                    <li>{t('Max Engines')}</li>
                                    <li>{t('Cloud Engines')}</li>
                                </ul>
                            </Col>
                            <Col xs={3} md={3} lg={3} className={noPaddingClass}>
                                <h5>{t('Vulnerable Time*')}</h5>
                                <ul>
                                    { totalDetectionTimeDom }
                                </ul>
                            </Col>
                            <Col xs={3} md={3} lg={3} className={noPaddingClass}>
                                <h5>{t('Outbreaks detected')}</h5>
                                <ul>
                                    { totalDetectionCountDom }
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            {belowOutbreakReportDom}
        </section>
    );

};

DetectionReport.propTypes = {
    data: PropTypes.array.isRequired,
    tableLegend: PropTypes.any,
    currentReportDate: PropTypes.string,
    latestDate: PropTypes.string
};

export default DetectionReport;
